var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachineCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 590.342 542.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VIVI_Panels"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "518.097 0 445.442 41.947 517.656 83.553 590.311 41.606 518.097 0",
    fill: "#ffcfae"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "517.71 83.585 517.71 88.99 590.342 47.03 590.342 41.624 517.71 83.585",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "517.71 83.585 517.71 88.99 445.462 47.365 445.462 41.959 517.71 83.585",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "444.685 42.353 372.03 84.3 444.244 125.906 516.899 83.959 444.685 42.353",
    fill: "#ffcfae"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.298 125.937 444.298 131.343 516.93 89.383 516.93 83.977 444.298 125.937",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.298 125.937 444.298 131.343 372.051 89.718 372.051 84.312 444.298 125.937",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "371.274 84.706 298.619 126.653 370.833 168.259 443.488 126.312 371.274 84.706",
    fill: "#ffcfae"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.887 168.29 370.887 173.696 443.519 131.736 443.519 126.33 370.887 168.29",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.887 168.29 370.887 173.696 298.639 132.071 298.639 126.665 370.887 168.29",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "298.427 127.059 225.772 169.006 297.986 210.612 370.641 168.665 298.427 127.059",
    fill: "#ffcfae"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.04 210.643 298.04 216.049 370.672 174.088 370.672 168.683 298.04 210.643",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.04 210.643 298.04 216.049 225.792 174.424 225.792 169.018 298.04 210.643",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "225.015 169.411 152.36 211.359 224.574 252.965 297.229 211.018 225.015 169.411",
    fill: "#ffcfae"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.628 252.996 224.628 258.402 297.26 216.441 297.26 211.035 224.628 252.996",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.628 252.996 224.628 258.402 152.381 216.777 152.381 211.371 224.628 252.996",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "151.603 212.047 78.948 253.994 151.162 295.6 223.817 253.653 151.603 212.047",
    fill: "#ffcfae"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.216 295.631 151.216 301.037 223.848 259.076 223.848 253.671 151.216 295.631",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.216 295.631 151.216 301.037 78.969 259.412 78.969 254.006 151.216 295.631",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "78.192 254.399 5.537 296.347 77.751 337.953 150.406 296.006 78.192 254.399",
    fill: "#ffcfae"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.805 337.984 77.805 343.39 150.437 301.429 150.437 296.023 77.805 337.984",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.805 337.984 77.805 343.39 5.557 301.765 5.557 296.359 77.805 337.984",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0 500.521 72.655 542.468 72.655 345.708 0 303.76 0 500.521",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.401,472.648h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.031,469.149h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.574,464.665h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.204,461.165h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.746,456.682h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.376,453.182h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.401,491.259h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.031,487.759h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.574,483.275h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.204,479.776h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.746,475.292h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.376,471.793h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.401,509.869h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.031,506.37h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.574,501.886h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.204,498.386h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.746,493.903h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.376,490.403h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.401,417.685h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.031,414.185h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.574,409.701h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.204,406.202h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.746,401.718h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.376,398.218h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.401,436.295h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.031,432.796h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.574,428.312h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.204,424.812h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.746,420.329h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.376,416.829h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.401,454.906h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.031,451.406h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.574,446.923h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.204,443.423h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.746,438.939h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.376,435.44h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.401,362.721h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.031,359.222h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.574,354.738h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.204,351.238h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.746,346.755h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.376,343.255h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.401,381.332h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.031,377.832h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.574,373.349h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.204,369.849h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.746,365.365h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.376,361.866h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.401,399.943h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.031,396.443h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.574,391.959h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.204,388.46h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.746,383.976h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.376,380.476h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.209,338.937h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.839,335.438h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.381,330.954h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.011,327.454h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.209,357.548h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.839,354.048h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.381,349.564h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.011,346.065h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.209,376.158h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.839,372.659h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.381,368.175h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.011,364.675h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.209,448.864h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.839,445.364h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.381,440.881h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.011,437.381h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.209,467.475h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.839,463.975h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.381,459.491h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.011,455.992h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.209,486.085h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.839,482.586h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.381,478.102h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.011,474.602h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.209,393.901h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.839,390.401h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.381,385.917h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.011,382.418h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.209,412.511h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.839,409.012h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.381,404.528h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.011,401.028h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.209,431.122h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.839,427.622h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.381,423.139h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.011,419.639h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "72.655 345.645 77.337 342.942 4.682 301.022 0 303.724 72.655 345.645",
    fill: "#ffcfae"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.655 345.645 77.337 342.942 77.337 539.741 72.655 542.565 72.655 345.645",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.426,528.738h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.056,525.238h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.599,520.755h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.229,517.255h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.771,512.771h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.401,509.272h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.234,504.954h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.864,501.454h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.406,496.971h0c.9,.52,1.63-.032,1.63-1.232v-7.999c0-1.2-.73-2.595-1.63-3.115h0c-.9-.52-1.63,.032-1.63,1.232v7.999c0,1.2,.73,2.595,1.63,3.115Z",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.036,493.471h0c0-1.2-.73-2.595-1.63-3.115l-6-3.464c-.9-.52-1.63,.032-1.63,1.232h0c0,1.2,.73,2.595,1.63,3.115l6,3.464c.9,.52,1.63-.032,1.63-1.232Z",
    fill: "#e8b185"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineCart);
export default __webpack_public_path__ + "static/media/machine-cart.ad6e2dc0212b018c86f3bff2b02893ee.svg";
export { ForwardRef as ReactComponent };